import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { CustomEmoji } from '@avslack/shared';
import { listCustomEmoji } from '../lib/api';

export const customEmojiKey = ['custom-emoji'] as const;

/**
 * A workspace sajat emojijai.
 *
 * Ritkan valtozik, viszont MINDEN uzenetnel es reakcional kell - ezert hosszu
 * a `staleTime`. A cim az emoji azonositojat tartalmazza, tehat egy csere uj
 * cimet jelent: nem kell rovid gyorsitotarral vedekezni a beragadas ellen.
 */
export function useCustomEmoji() {
  const query = useQuery({
    queryKey: customEmojiKey,
    queryFn: listCustomEmoji,
    staleTime: 10 * 60_000,
  });

  const byName = useMemo(() => {
    const map = new Map<string, CustomEmoji>();
    for (const emoji of query.data ?? []) map.set(emoji.name, emoji);
    return map;
  }, [query.data]);

  return { emoji: query.data ?? [], byName };
}

/** `:nev:` alaku hivatkozas - ezt keressuk a szovegben es a reakciokban. */
export const CUSTOM_EMOJI_RE = /:([a-z0-9][a-z0-9_-]{0,30}):/g;
